var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 337,
    height: 339,
    viewBox: "0 0 337 339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-418.671,262.058A156.413,156.413,0,0,1-459,157,157,157,0,0,1-302,0,156.855,156.855,0,0,1-171.327,69.944,156.438,156.438,0,0,1-131,175,157,157,0,0,1-288,332,156.847,156.847,0,0,1-418.671,262.058Z",
    transform: "translate(450 4)",
    fill: "#2603b2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-nat"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 337,
    height: 339
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nat",
    clipPath: "url(#clip-nat)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(14 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-69 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 157,
    cy: 157,
    r: 157,
    transform: "translate(74 18)",
    fill: "#2603b2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 157,
    cy: 157,
    r: 157,
    transform: "translate(60)",
    fill: "#026fd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M29,266.115c8.083,5.241,29.28,18.111,76-8.594,58.4-33.382,81.277-51.217,120.844-35.335S340.718,321.23,417,301.5",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M2,194.061c27.427-6.643,71.52-28.891,96.9-51.218,27.014-23.767,57.945-26.933,81.179-11.867s88.147,70.831,155.912,85.615c54.212,11.827,110.454-17.914,136.735-42.673",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M37,69.889c18.908-.548,28.026,15.021,82.187,0S216,20.871,253.5,50.435s70.324,72.527,116,75.565c45.2,3.006,71.507-56.077,84.143-75.565",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 15
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNat);
export default __webpack_public_path__ + "static/media/nat.2bf723b25d6e51120eaf72f6907a2533.svg";
export { ForwardRef as ReactComponent };